/** =========================================================
 * Module: trigger-resize.js
 * Triggers a window resize event from any element
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .directive('triggerResize', triggerResize);

  triggerResize.$inject = ['$window', '$timeout'];

  function triggerResize($window, $timeout) {
    var directive = {
      link: link,
      restrict: 'A'
    };

    return directive;

    function link(scope, element, attributes) {
      element.on('click', function () {
        $timeout(function () {
          // all IE friendly dispatchEvent
          var evt = document.createEvent('UIEvents');
          evt.initUIEvent('resize', true, false, $window, 0);
          $window.dispatchEvent(evt);
          // modern dispatchEvent way
          // $window.dispatchEvent(new Event('resize'));
        }, attributes.triggerResize || 300);
      });
    }
  }
})();
